import React,{useState,useEffect} from 'react'
import "./PopularBlogs.css"
import BlogCard from './BlogCard'
import PopularBlogCard from './PopularBlogCard'
import axios from "axios"
import {useNavigate} from "react-router-dom"
import {Spinner} from "react-bootstrap"
import { blogData } from '../../screens/BlogsData'


const blogsDummy = [
  {
    catagory: "Knowledge",
    date: "Apr 10, 2023",
    main_heading:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    paragraph:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
      blog_creative: "/images/icons/blog-card-thumbnail.png",
    slug_url: "bloginner",
  },
  {
    catagory: "Knowledge",
    date: "Apr 10, 2023",
    main_heading:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    paragraph:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    blog_creative: "/images/icons/blog-card-thumbnail.png",
    slug_url: "bloginner",
  },
  {
    catagory: "Knowledge",
    date: "Apr 10, 2023",
    main_heading:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    paragraph:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
      blog_creative: "/images/icons/blog-card-thumbnail.png",
    slug_url: "bloginner",
  },
  
];

const popularBlogDate = [
  {
    logo:"/images/icons/blog-card-thumbnail.png",
    blog_description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    date: "Apr 10, 2023",
    slug_url:"bloginner"
  },
  {
    logo:"/images/icons/blog-card-thumbnail.png",
    blog_description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    date: "Apr 10, 2023",
    slug_url:"bloginner"
  },
  {
    logo:"/images/icons/blog-card-thumbnail.png",
    blog_description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    date: "Apr 10, 2023",
    slug_url:"bloginner"
  },
  
];

let defaultBlogObj= [];



function PopularBlogs({selectedCatagory}) {
  const [blogs, setBlogs] = useState([]);
  const [recentBlogs, setRecentBlogs] = useState([]);

  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  let blogAPICalled = false;

  useEffect(() => {
    getAllBlogsListing();
  }, []);

  const getAllBlogsListing = () => {
    if (blogAPICalled) return;
    blogAPICalled = true;

    setLoading(true);
    axios
      .get("/blogs", {})
      .then((res) => {
        if (res.data.status === "success") {
          let Updated_data_Blogs = [];
          let Updated_recent_blogs = [];
          res.data.data.forEach((item) => {
            if(item.category == selectedCatagory || selectedCatagory == 0)
            {

              Updated_data_Blogs.push({
                id: item.blog_id,
                main_heading: item.title,
                paragraph: item.brief_paragraph,
                logo: "/favicon.png",
                entity: "Creative Squad",
                date: item.published_date,
                slug_url: item.slug_url,
                category: item.category,
                blog_creative: item.blog_image,
              });
            }
          });
          res.data.data.forEach((item) => {
            Updated_recent_blogs.push({
              id: item.blog_id,
              slug_url: item.slug_url,
              logo: item.blog_image,
              blog_description: item.title,
              date: item.published_date,
            });
          });
          setRecentBlogs(Updated_recent_blogs.slice(0, 3));
          setBlogs(Updated_data_Blogs);
          defaultBlogObj = Updated_data_Blogs;
          
          setLoading(false);
        }
          
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const convertToSlug = (str) => {
    return str.toLowerCase().replace(/\s+/g, "-");
  };

  const redirectUserToBlog = (id) => {
    if (!id) return;
    let slug = convertToSlug(id);

    navigate(`/blog/${slug}`);
  };

  

  return (
    <div className='popular-blog-container standard-padding-space'>
        {/* {loading ? 
        (<div className="w-100 text-center mb-5">
          <Spinner
            style={{ color: "#A1845D", width: "120px", height: "120px" }}
          />
        </div>):( */}
        <div className='container'>
            <div className='row justify-content-between'>
                <div className='col-md-6 '>
                    

                    {
                        // currentNewsData.map((ele)=>{
                          blogs.map((ele,ind)=>{
                            return(
                                <BlogCard
                                    title={ele.main_heading}
                                    content={ele.paragraph}
                                    img={ele.blog_creative}
                                    anchor={ele.slug_url}
                                    redirectionFunction={redirectUserToBlog}
                                    date={ele.date}
                                    />)
                        })
                    }
                    

                </div>
                <div className='col-md-5 ' >
                    <div className='popular-card-container p-3'>
                    <h4 className='body-heading mb-4 mt-3 text-center text-xl-start' style={{fontSize:"20px" , color: "#1e1e1e" , fontWeight: 700}}>Most Popular Blogs</h4>
                    {
                        recentBlogs.map((ele,ind)=>{
                            return(
                                <PopularBlogCard
                                img={ele.logo}
                                title={ele.blog_description}
                                anchor={ele.slug_url}
                                redirectionFunction={redirectUserToBlog}
                                // img={ele.img}
                                // title={ele.heading}
                                // anchor={ind}
                                // redirectionFunction={redirectUserToBlog}
                                />
                            )
                        })
                    }
                    </div>
                </div>
            </div>

            {/* <div className="page-btn-container my-5 d-flex align-items-center justify-content-md-center justify-content-center  gap-3">
              
                 {[...Array(Math.ceil(blogs.length / itemsPerPage)).keys()].map((page) => {
                    if (page + 1 <= 3) {
                      return (
                        <button
                          key={page + 1}
                          className={currentPage === page + 1 ? 'active' : ''}
                          onClick={() => handlePageChange(page + 1)}
                        >
                          {page + 1}
                        </button>
                      );
                    } else {
                      return (
                        <button key="next" onClick={() => handlePageChange(currentPage + 1)}>
                          <img src="/images/icons/next-btn-icon.svg" className="next-icon" alt="arrow " />
                        </button>
                      );
                    }
                  })}
            </div> */}

        {/* </div>)} */}
    </div>
    </div>
  )
}

export default PopularBlogs